import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Typography,
  useMediaQuery,
} from '@material-ui/core/'
import { useTheme } from '@material-ui/core/styles'
import classnames from 'classnames'
import React, { useEffect, useState } from 'react'
import InputSectionLayout from './checkout/InputSectionLayout'
import useStyles from './DeliveryTimePicker.style.js'
import ControlledSelect from './ui-kit/ControlledSelect/ControlledSelect.jsx'

const DATE_FORMAT = { hour: '2-digit', minute: '2-digit' }

const formatTime = (deliveryTime, isAsap) => {
  const { start_at, startAt, end_at, endAt } = deliveryTime
  const startTime = new Date(start_at || startAt)
  const endTime = new Date(end_at || endAt)
  const timeString =
    startTime.getTime() === endTime.getTime()
      ? `${endTime.toLocaleTimeString([], DATE_FORMAT)}`
      : `${startTime.toLocaleTimeString([], DATE_FORMAT)} - ${endTime.toLocaleTimeString(
          [],
          DATE_FORMAT
        )}`

  if (isAsap) {
    return (
      <span>
        <span style={{ fontWeight: 'bold' }}>ASAP</span> ({timeString})
      </span>
    )
  }
  return timeString
}

/**
 * A form control to let you pick from given deliveryTimes.
 * @param {Object} props
 * @param {ShoppingCartState.TimeRange[]} props.deliveryTimes
 * @param {Function} props.onSelect
 * @param {Object} props.error
 */
const DeliveryTimePicker = (props) => {
  const classes = useStyles()
  const [deliveryTimeIndex, setDeliveryTimeIndex] = useState(0)
  const { deliveryTimes, onSelect, error, isPickup } = props
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  useEffect(() => {
    if (deliveryTimes && deliveryTimes.length > 0) {
      onSelect(deliveryTimes[0])
    }
  }, [deliveryTimes])

  const handleChange = (e) => {
    const deliveryTimeIndex = e.target.value
    setDeliveryTimeIndex(deliveryTimeIndex)
    onSelect && onSelect(deliveryTimes[deliveryTimeIndex])
  }

  const errorClass = error ? classes.errorText : null
  const formHelperTextClass = classnames(classes.formHelperText, errorClass)

  const formHelperText = error
    ? error.message
    : isPickup
    ? 'Please select a currently available pickup time.'
    : 'Please select a currently available delivery time.'

  if (!deliveryTimes) {
    return null
  }

  return (
    <InputSectionLayout
      left={
        <>
          <FormHelperText className={formHelperTextClass}>{formHelperText}</FormHelperText>
          <FormControl variant='outlined' fullWidth className={classes.formControl}>
            <ControlledSelect
              value={deliveryTimeIndex}
              onChange={handleChange}
              inputProps={{
                name: 'deliveryTime',
                id: 'deliveryTime',
              }}
              controlLabel={isMobile ? 'Choose' : 'Choose another time'}>
              {deliveryTimes.map((time, index) => (
                <MenuItem key={index} value={index}>
                  <Grid container alignItems='center'>
                    <Typography data-loacator='delivery-time'>
                      {formatTime(time, index === 0)}
                    </Typography>
                  </Grid>
                </MenuItem>
              ))}
            </ControlledSelect>
          </FormControl>
        </>
      }></InputSectionLayout>
  )
}

export default DeliveryTimePicker
